import { Component, Input, OnInit } from '@angular/core';
import { trimText } from 'src/app/core/utils/global-utils';
import { MspTicket } from '../../../interfaces/msp-ticket';
import { FeaturesFlagsV2Service } from 'src/app/core/services/features-flags-v2.service';

@Component({
  selector: 'msp-ticket-detail-card-details',
  templateUrl: './ticket-detail-card-details.component.html',
  styleUrls: ['./ticket-detail-card-details.component.scss'],
  standalone: false,
})
export class TicketDetailCardDetailsComponent implements OnInit {
  /** Hold ticket details */
  @Input() ticket: MspTicket;
  /** Hold loading state */
  @Input() isLoadingData: boolean;

  isBusinessUnitEnabled = false;

  constructor(private featuresFlagsV2Service: FeaturesFlagsV2Service) {}

  ngOnInit(): void {
    this.featuresFlagsV2Service.featuresFlags$.subscribe((flags) => {
      this.isBusinessUnitEnabled = flags.some((f) => f.feature === 'business-unit' && f.isActive);
    });
  }

  /**
   * Trims the given email to a maximum number of characters in resources box
   */
  trimResource(email: string): string {
    const MAX_CHARS = 18;
    return trimText(email, MAX_CHARS);
  }

  /**
   * Trims the given email to a maximum number of characters in contact email field
   */
  trimContactEmail(email: string): string {
    const MAX_CHARS = 20;
    return trimText(email, MAX_CHARS);
  }
}
